import { trackEvent, eventNameConstants } from 'dibs-tracking';

export const ATTRIBUTE_SEARCH_CORRECTION = 'data-static-tracking-search-correction';
export const ATTRIBUTE_SEARCH_AUTO_CORRECT = 'data-static-tracking-auto-correction';
const SEARCH_SPELLING_AUTO_CORRECTED = 'search spelling autocorrected';
const CATEGORY_SEARCH_SUGGESTION_TEXT = 'search suggestion text';

export const trackSearchCorrectionClick = (
    correctedTerm: string,
    originalTerm: string,
    overrideType: string,
    trigger?: string | null
): void =>
    trackEvent({
        label: `${correctedTerm}|${originalTerm}`,
        category: CATEGORY_SEARCH_SUGGESTION_TEXT,
        action: `${overrideType} override clicked`,
        eventName: eventNameConstants.EVENT_NAVIGATION,
        interaction_type: SEARCH_SPELLING_AUTO_CORRECTED,
        step_interaction_name: originalTerm,
        trigger,
    });

export const trackAutoCorrectClick = (
    correctedTerm: string,
    originalTerm: string,
    trigger?: string | null
): void =>
    trackEvent({
        category: CATEGORY_SEARCH_SUGGESTION_TEXT,
        action: 'override spelling autocorrect',
        label: `${correctedTerm}|${originalTerm}`,
        eventName: eventNameConstants.EVENT_NAVIGATION,
        interaction_type: SEARCH_SPELLING_AUTO_CORRECTED,
        step_interaction_name: originalTerm,
        trigger,
    });

export const trackAutoCorrectView = (
    correctedTerm: string,
    originalTerm: string,
    trigger?: string | null
): void =>
    trackEvent({
        category: CATEGORY_SEARCH_SUGGESTION_TEXT,
        action: 'spelling autocorrect',
        label: `${correctedTerm}|${originalTerm}`,
        eventName: eventNameConstants.EVENT_NAVIGATION,
        interaction_type: SEARCH_SPELLING_AUTO_CORRECTED,
        step_interaction_name: `${correctedTerm} | ${originalTerm}`,
        trigger,
    });

export function encodeForceSearchTrackingData<T>(data: T): string {
    return JSON.stringify(data);
}
